const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ?? "http://127.0.0.1:8000";

console.log("API_BASE_URL: ", API_BASE_URL);
type ApiGetOptions = {
  signal?: AbortSignal;
};

export async function apiGet<T = any>(
  path: string,
  options: ApiGetOptions = {}
): Promise<T> {
  const { signal } = options;

  const res = await fetch(`${API_BASE_URL}${path}`, { signal });
  if (!res.ok) {
    throw new Error(`API ${path} failed with ${res.status}`);
  }
  return res.json() as Promise<T>;
}

export async function apiPostForm<T = any>(
  path: string,
  formData: FormData,
  options: ApiGetOptions = {}
): Promise<T> {
  const { signal } = options;
  const res = await fetch(`${API_BASE_URL}${path}`, {
    method: "POST",
    body: formData,
    signal,
  });
  if (!res.ok) {
    const detail = await res.json().catch(() => ({}));
    const message =
      detail?.detail && Array.isArray(detail.detail)
        ? detail.detail.join(" ")
        : detail?.detail || `API ${path} failed with ${res.status}`;
    throw new Error(message);
  }
  return res.json() as Promise<T>;
}
